// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"BackToTop_backToTop__Yu5HO","backToTopIcon":"BackToTop_backToTopIcon__3Jglc"};